module.exports = __webpack_public_path__ + "img/main3.921858ad.png";